import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, BookOpenIcon, ClipboardCheckIcon, UsersIcon, MicIcon, UtensilsIcon, GiftIcon, ArrowRightIcon } from 'lucide-react';
export const Bonuses = () => {
  const bonuses = [{
    num: 'Bonus 1',
    title: 'Kit de 36 Herramientas Listas para Usar',
    desc: 'Formularios, contratos, checklists, guiones de clase, mensajes de WhatsApp y calculadoras. Bajás, imprimís y usás mañana mismo.',
    pages: '40 págs.',
    icon: WrenchIcon
  }, {
    num: 'Bonus 2',
    title: 'Glosarios por Perfil: Fotocopiables y Listos',
    desc: '+500 términos organizados para ciudadanía, CILS/CELI, corporativo y errores del rioplatense. Con tarjetas para recortar y ejercicios de repaso.',
    pages: '40 págs.',
    icon: BookOpenIcon
  }, {
    num: 'Bonus 3',
    title: 'Simulacros Reales con Claves de Corrección',
    desc: 'Entrevista consular simulada con guión y rúbrica. Examen tipo CILS B1 completo con respuestas. El recurso que ningún manual trae.',
    pages: '40 págs.',
    icon: ClipboardCheckIcon
  }, {
    num: 'Bonus 4',
    title: 'Tu Primer Taller o Programa Grupal',
    desc: 'Paso a paso para armar un programa grupal de 4 a 8 semanas, fijar el precio y conseguir los primeros inscriptos sin improvisar.',
    pages: '40 págs.',
    icon: UsersIcon
  }, {
    num: 'Bonus 5',
    title: 'Guía de Pronunciación para el Oído Rioplatense',
    desc: 'Los sonidos que más le cuestan al argentino — dobles consonantes, vocales abiertas, entonación — con ejercicios fonéticos progresivos.',
    pages: '40 págs.',
    icon: MicIcon
  }, {
    num: 'Bonus 6',
    title: 'Banco de 30 Actividades Culturales Listas',
    desc: 'Actividades basadas en gastronomía, cine, regiones e historia italiana. Diseñadas para romper la rutina y hacer que el alumno recomiende tus clases.',
    pages: '40 págs.',
    icon: UtensilsIcon
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.35,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-10 md:py-20 px-5 bg-bg-alt pt-[30px] pb-[30px]" data-id="element-25">
      <div className="max-w-[860px] mx-auto" data-id="element-26">
        <div className="text-center mb-8 md:mb-10" data-id="element-27">
          <p className="text-xs tracking-[0.1em] uppercase text-verde mb-3 font-semibold inline-flex items-center gap-1.5" data-id="element-28">
            <GiftIcon size={12} data-id="element-29" /> Incluidos gratis
          </p>
          <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2] mb-3" data-id="element-30">
            6 Bonos Estratégicos
          </h2>
          <p className="text-[15px] md:text-[16px] text-[#aaa] max-w-[580px] mx-auto" data-id="element-31">
            Sin costo extra — incluidos en ambas ofertas
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="flex flex-col gap-2.5" data-id="element-32">
          {bonuses.map((b, i) => {
          const Icon = b.icon;
          return <motion.div key={i} variants={item} whileHover={{
            x: 4
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 22
          }} className="group relative bg-gris-oscuro border border-gris-medio rounded-xl overflow-hidden hover:border-verde/40 hover:shadow-[0_0_20px_rgba(34,197,94,0.05)] transition-all duration-300" data-id="element-33">
                <div className="flex items-stretch gap-0" data-id="element-34">
                  {/* Icon panel — acts as the representative "image" */}
                  <div className="relative shrink-0 w-[68px] sm:w-[88px] flex items-center justify-center bg-gradient-to-br from-verde/15 to-verde/[0.03] border-r border-verde/15" data-id="element-35">
                    <div className="absolute inset-0 bg-verde/5 group-hover:bg-verde/10 transition-colors" data-id="element-36"></div>
                    <Icon size={28} strokeWidth={1.8} className="text-verde relative z-10 transition-transform duration-300 group-hover:scale-110" aria-hidden="true" data-id="element-37" />
                    <span className="absolute top-1.5 left-1.5 text-[8.5px] font-bold tracking-wider text-verde/70 uppercase" aria-label={b.num} data-id="element-38">
                      0{i + 1}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0 p-3 sm:p-4" data-id="element-39">
                    <div className="flex items-start justify-between gap-2 mb-1" data-id="element-40">
                      <p className="text-[10px] font-bold text-verde tracking-widest uppercase" data-id="element-41">
                        {b.num}
                      </p>
                      <span className="shrink-0 inline-flex items-center text-[10px] font-bold bg-verde/10 text-verde px-2 py-0.5 rounded-full border border-verde/20 whitespace-nowrap" data-id="element-42">
                        GRATIS · {b.pages}
                      </span>
                    </div>
                    <p className="text-[14px] sm:text-[15px] font-bold text-blanco leading-snug mb-1" data-id="element-43">
                      {b.title}
                    </p>
                    <p className="text-[12px] sm:text-[12.5px] text-[#aaa] leading-relaxed line-clamp-2 sm:line-clamp-none" data-id="element-44">
                      {b.desc}
                    </p>
                  </div>

                  {/* Arrow accent */}
                  <div className="hidden md:flex shrink-0 items-center pr-4" data-id="element-45">
                    <ArrowRightIcon size={16} className="text-gris-claro/40 group-hover:text-verde group-hover:translate-x-1 transition-all duration-300" data-id="element-46" />
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>

        <p className="text-center mt-7 text-[14px] md:text-[15px] font-bold text-gris-claro" data-id="element-47">
          VALOR TOTAL DE LOS BONOS:{' '}
          <span className="line-through text-gris-claro/50" data-id="element-48">$48.000</span> —{' '}
          <span className="text-verde" data-id="element-49">INCLUIDOS GRATIS</span>
        </p>
      </div>
    </section>;
};